import React, { lazy, Suspense } from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';

import FullLoader from '../../components/FullLoader';
import DashboardLayout from '../../layouts/DashboardLayout';
import { ACCOUNTS, CARTS, STORES, USERS } from '../../settings/constants';

const Accounts = lazy(() => import('../../screens/Accounts'));
const Account = lazy(() => import('../../screens/Account'));
const Customers = lazy(() => import('../../screens/Customers'));
const Customer = lazy(() => import('../../screens/Customer'));
const Stores = lazy(() => import('../../screens/Stores'));
const Store = lazy(() => import('../../screens/Store'));
const Carts = lazy(() => import('../../screens/Carts'));
const Cart = lazy(() => import('../../screens/Cart'));

const Home = () => {
	const { path } = useRouteMatch();

	return (
		<DashboardLayout>
			<Suspense fallback={<FullLoader />}>
				<Switch>
					<Route exact path={`${path}/`}>
						<Redirect to={`${path}${USERS}`} />
					</Route>
					<Route exact path={`${path}${USERS}`}>
						<Customers />
					</Route>
					<Route exact path={`${path}${USERS}/:id`}>
						<Customer />
					</Route>
					<Route exact path={`${path}${ACCOUNTS}`}>
						<Accounts />
					</Route>
					<Route exact path={`${path}${ACCOUNTS}/:id`}>
						<Account />
					</Route>
					<Route exact path={`${path}${STORES}`}>
						<Stores />
					</Route>
					<Route exact path={`${path}${STORES}/:id`}>
						<Store />
					</Route>
					<Route exact path={`${path}${CARTS}`}>
						<Carts />
					</Route>
					<Route exact path={`${path}${CARTS}/:id`}>
						<Cart />
					</Route>
				</Switch>
			</Suspense>
		</DashboardLayout>
	);
};

export default Home;
